import instance from 'api';
import {
  IPurchaseApplication,
  IMaterial,
  IPurchaseApplicationStatus,
  IPosition,
  Checked1cMaterialBalance,
  IPurchaseApplicationHistory,
} from './interfaces';

export const loadPurchaseApplication = (applicationNumber: string) => {
  return instance()
    .get<IPurchaseApplication>(`/purchase/${applicationNumber}/load`)
    .then((response) => response.data);
};

export const loadPurchaseApplicationHistory = (applicationNumber: string) => {
  return instance()
    .get<IPurchaseApplicationHistory>(`/purchase/${applicationNumber}/history`)
    .then((response) => response.data);
};

export const returnToDraftPurchaseApplication = (applicationNumber: string) => {
  return instance()
    .post(`/purchase/${applicationNumber}/status/draft`)
    .then((response) => response.data);
};

export const saveOrUpdatePurchaseApplication = (purchaseApplication: IPurchaseApplication) => {
  return instance()
    .post(`/purchase/${purchaseApplication.applicationNumber}/saveUpdate`, purchaseApplication)
    .then((response) => response.data);
};

export const completePurchaseApplication = (applicationNumber: string) => {
  return instance()
    .post(`/purchase/${applicationNumber}/completed`)
    .then((response) => response.data);
};

export const check1cPurchaseApplicationMaterials = (applicationNumber: string) => {
  return instance()
    .post<Checked1cMaterialBalance[]>(`/purchase/${applicationNumber}/check1c`)
    .then((response) => response.data);
};

export const revokePurchaseApplication = (applicationNumber: string) => {
  return instance()
    .post(`/purchase/${applicationNumber}/rejectUnityBpm`)
    .then((response) => response.data);
};

export const approvePurchaseApplication = (applicationNumber: string) => {
  return instance()
    .post(`/purchase/${applicationNumber}/sendUnityBpm`)
    .then((response) => response.data);
};

export const getPurchaseApplicationStatuses = () => {
  return instance()
    .post<IPurchaseApplicationStatus[]>(`/purchase/status/listAll`)
    .then((response) => response.data);
};

export const getPurchaseApplicationMaterials = () => {
  return instance()
    .post<IMaterial[]>(`/purchase/material/listAll`)
    .then((response) => response.data);
};

// Dictionaries
export const getPositions = () => {
  return instance()
    .post<IPosition[]>('/dictionary/adminPositions', { headPositionId: null, includeDeleted: false })
    .then((response) => response.data);
};
